import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
// graphQL
import gql from 'graphql-tag';
// our components
import StatsPeriod from 'components/common/StatsPeriod/StatsPeriod';
import Metrics from 'components/common/Metrics/Metrics';

export const NEW_USERS_METRIC_QUERY = gql`
  query newUsersMetric($minDate: Date!, $maxDate: Date!) {
    registeredUsersStats(minDate: $minDate, maxDate: $maxDate) {
      plot {
        date
        value
      }
    }
  }
`;

const UserMetricsContainer = ({ t }) => (
  <StatsPeriod query={NEW_USERS_METRIC_QUERY} defaultLast="week">
    {({ data, updateData }) => (
      <Metrics
        title={t('common.sidemenu.users')}
        data={
          data && data.registeredUsersStats
            ? data.registeredUsersStats.plot
            : []
        }
        statsUpdate={date => updateData(date)}
      />
    )}
  </StatsPeriod>
);

UserMetricsContainer.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(UserMetricsContainer);
